import React, { FC, useEffect, useState } from "react";
import { Tab } from "../../atoms/Tab";
import { HeaderText, Wrapper } from "./elements";
import {
  NewApplicants,
  Shortlisted,
  Testdome,
  InitialInterview,
  ScouterTest,
  FinalInterview,
} from "../../organisms/PhaseTables";

type Props = {
  isLoading: boolean;
  onClickApplicant: (key: string) => void;
  tableData: any;
  defaultActiveKey: string;
  onTabClick: (key: string) => void;
  onChange?: (pagination: any, filters: any) => void;
  total: number;
  currentPage?: number | undefined;
};

const FailedApplicants: FC<Props> = ({
  isLoading,
  onClickApplicant,
  tableData,
  defaultActiveKey,
  onTabClick,
  onChange,
  total,
  currentPage,
}: any) => {
  const [rowRecord, setRowRecord] = useState<any>(null);

  useEffect(() => {
    if (rowRecord) {
      const key = rowRecord.key;
      onClickApplicant(key);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowRecord]);

  const tabs = [
    {
      title: "New Applicant",
      content: (
        <NewApplicants
          tableData={tableData}
          isLoading={isLoading}
          onClickApplicant={setRowRecord}
          total={total}
          onChange={onChange}
          currentPage={currentPage}
        />
      ),
    },
    {
      title: "Shortlisted",
      content: (
        <Shortlisted
          tableData={tableData}
          isLoading={isLoading}
          onClickApplicant={setRowRecord}
          total={total}
          onChange={onChange}
          currentPage={currentPage}
        />
      ),
    },
    {
      title: "Technical Exam",
      content: (
        <Testdome
          tableData={tableData}
          isLoading={isLoading}
          onClickApplicant={setRowRecord}
          total={total}
          onChange={onChange}
          currentPage={currentPage}
        />
      ),
    },
    {
      title: "Initial Interview",
      content: (
        <InitialInterview
          tableData={tableData}
          isLoading={isLoading}
          onClickApplicant={setRowRecord}
          total={total}
          onChange={onChange}
          currentPage={currentPage}
        />
      ),
    },
    {
      title: "Psychological Exam",
      content: (
        <ScouterTest
          tableData={tableData}
          isLoading={isLoading}
          onClickApplicant={setRowRecord}
          total={total}
          onChange={onChange}
          currentPage={currentPage}
        />
      ),
    },
    {
      title: "Final Interview",
      content: (
        <FinalInterview
          tableData={tableData}
          isLoading={isLoading}
          onClickApplicant={setRowRecord}
          total={total}
          onChange={onChange}
          currentPage={currentPage}
        />
      ),
    },
  ];

  return (
    <>
      <Wrapper>
        <HeaderText>Failed</HeaderText>
        <Tab
          tabs={tabs}
          onTabClick={onTabClick}
          defaultActiveKey={defaultActiveKey ? defaultActiveKey : "0"}
        />
      </Wrapper>
    </>
  );
};

export default FailedApplicants;
